import * as React from 'react';
const RadioGroupContext = /*#__PURE__*/React.createContext(null);
export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
export const RadioOptionTypeContext = /*#__PURE__*/React.createContext(null);
export const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/radio/context.js
// module id = 668
// module chunks = 0